import React from 'react';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import InlineComponents from '@bit/gerenciatd.unifiedcomponents.inline-components';
import './DeviceContent.scss';

export const DeviceContent = ({
  deviceInfo,
}) => {
  return (

    <div className="deviceContent">
      <InlineComponents direction="row" justify="flex-start" wrap="no-wrap" className="deviceContent--noMargin">
        <TextInfo
          className="deviceContent__nombre--titulo"
          text="Dispositivo: "
          kind={KIND_TEXT.PARAGRAPH}
          align={ALIGN.LEFT}
          color={COLOR.GREY_4}
          size={SIZE.CAPTION1}
          fontType={FONT_TYPE.REGULAR}
        />
        <TextInfo
          className="deviceContent__nombre--texto"
          text={deviceInfo.nombre}
          kind={KIND_TEXT.PARAGRAPH}
          align={ALIGN.LEFT}
          color={COLOR.GREY_6}
          size={SIZE.CAPTION1}
          fontType={FONT_TYPE.REGULAR}
        />
      </InlineComponents>
      <InlineComponents direction="row" justify="flex-start" wrap="no-wrap">
        <TextInfo
          className="deviceContent__fecha--fechafin"
          text={`Faltan ${deviceInfo.fechaFinal} meses: `}
          kind={KIND_TEXT.PARAGRAPH}
          align={ALIGN.LEFT}
          color={COLOR.GREY_4}
          size={SIZE.CAPTION1}
          fontType={FONT_TYPE.REGULAR}
        />
        <TextInfo
          className="deviceContent__fecha--price"
          text={deviceInfo.precio}
          kind={KIND_TEXT.PARAGRAPH}
          align={ALIGN.LEFT}
          color={COLOR.GREY_6}
          size={SIZE.CAPTION1}
          fontType={FONT_TYPE.REGULAR}
        />
      </InlineComponents>
    </div>
  );
}
export default DeviceContent;
